<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="620"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <div
              class="pa-4 popup-header">
              <div
                class="title font-weight-bold black--text text-center mb-1">
                Ketepatan Pekerjaan
              </div>

              <div
                class="body-1 text-center">
                Tentukan nilai berdasarkan informasi dibawah ini:
              </div>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <div
                    class="body-2 mb-8">
                    <ul
                      style="position: relative; left: -10px;">
                      <li
                        v-for="(item, index) in info"
                        :key="index"
                        :class="index < info.length - 1 ? 'mb-2' : ''"
                        v-html="item">  
                      </li>
                    </ul>
                  </div>

                  <v-row
                    class="mb-3">
                    <v-col
                      cols="12"
                      md="6"
                      class="pt-0">
                      <div>
                        <div 
                          class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Periode (Mulai)
                        </div>

                        <v-menu
                          ref="start_date"
                          min-width="290px"
                          max-width="290px"
                          transition="scale-transition"
                          offset-y
                          :nudge-right="40"
                          :close-on-content-click="false"
                          v-model="picker.start">
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider 
                              name="Periode (Mulai)" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                readonly
                                filled
                                rounded
                                dense

                                :color="set_color"
                                placeholder="Contoh. 2023-12-01"

                                hide-details

                                clearable
                                @click:clear="form.start_date = ''; form.end_date = '';"

                                v-on="on"
                                v-bind="attrs"

                                v-model="form.start_date"
                                :success="form.start_date !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>

                                  <div v-if="form.start_date !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </template>

                          <v-date-picker 
                            :max="max_date"
                            :color="set_color"
                            v-model="form.start_date"
                            @input="picker.start = false; form.end_date = '';">
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      class="pt-0">
                      <div>
                        <div 
                          class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Periode (Selesai)
                        </div>

                        <v-menu
                          ref="end_date"
                          min-width="290px"
                          max-width="290px"
                          transition="scale-transition"
                          offset-y
                          :nudge-right="40"
                          :close-on-content-click="false"
                          v-model="picker.end">
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider 
                              name="Periode (Selesai)" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                readonly
                                filled
                                rounded
                                dense

                                :color="set_color"
                                placeholder="Contoh. 2023-12-10"

                                hide-details

                                clearable
                                @click:clear="form.end_date = ''"

                                v-on="on"
                                v-bind="attrs"

                                v-model="form.end_date"
                                :success="form.end_date !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>

                                  <div v-if="form.end_date !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </template>

                          <v-date-picker 
                            :min="form.start_date"
                            :max="max_date"
                            :color="set_color"
                            v-model="form.end_date"
                            @input="picker.end = false">
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>

                  <ValidationProvider 
                    name="Masukan Nilai" 
                    rules="required|max_100:100"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Masukan Nilai
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      :color="set_color"
                      hide-details
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"

                      placeholder="Contoh. 70"

                      @focus="$event.target.select()"

                      suffix="%"

                      v-model="form.label_score"
                      :success="form.label_score !== '' && valid"
                      :error-messages="errors"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.label_score !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Kategori Penilaian" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kategori Penilaian
                    </div>

                    <v-select
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Bulanan"

                      hide-details
                      
                      :items="master_category_score"
                      item-value="kategori_penilaian"
                      item-text="kategori_penilaian"
                      :item-color="set_color"

                      v-model="form.note"
                      :success="form.note !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-2"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.note !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.reset"
          @keydown.esc="dialog.reset = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right font-weight-bold popup-header">
              Reset Nilai

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = {};"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin mereset nilai data <b class="font-weight-bold black--text">Tugas Utama Ketepatan Pekerjaan</b> ini?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="resetes()"
                :loading="process.reset"
                :disabled="process.reset"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Reset
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = {};"
                :disabled="process.reset"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.attachment"
          @keydown.esc="dialog.attachment = false"
          :fullscreen="dialog.fullscreen"
          width="1080"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right font-weight-bold popup-header">
              Lampiran

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.attachment = false; dialog.fullscreen = false; selected.item = {};"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text v-if="Object.keys(selected.item).length > 0"
              class="mt-4">
              <div v-if="selected.item.attachment.split('.').pop() !== 'pdf'">
                <v-img
                  contain
                  alt="humax" 
                  width="100%"
                  height="auto"
                  :src="selected.item.attachment"
                  class="ma-auto border-radius">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>

              <div v-else>
                <iframe 
                  :src="`${selected.item.attachment}#toolbar=0`" 
                  allowfullscreen
                  frameborder="0" 
                  width="100%"
                  height="600"
                  style="border-radius: 10px; border: 2px solid #323639;">
                </iframe>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="dialog.attachment = false; dialog.fullscreen = false; selected.item = {};"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12"
              md="6">
              <v-card
                @click="$router.go(-1)"
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="humax"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    {{ $route.name }}
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                class="mb-6"
                :color="set_color_rgb_down"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="10"
                      class="py-0">
                      <div
                        class="d-flex align-center">
                        <v-avatar 
                          size="40" 
                          tile>
                          <v-img 
                            alt="humax" 
                            :src="detail.image_url !== '' ? detail.image_url : require('@/assets/image/member_default.png')"
                            class="ma-auto"
                            style="border-radius: 10px;">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="white">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>

                        <div
                          class="font-weight-bold black--text ml-4">
                          {{ detail.code }}
                        </div>

                        <v-divider
                          vertical
                          class="my-2 mx-4"
                          style="border: 1px solid #fff; border-radius: 50px;" />

                        <div
                          class="font-weight-bold black--text">
                          {{ detail.name }}
                        </div>

                        <v-divider
                          vertical
                          class="my-2 mx-4"
                          style="border: 1px solid #fff; border-radius: 50px;" />

                        <div
                          class="font-weight-bold black--text">
                          {{ detail.position }}
                        </div>
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="2"
                      class="py-0">
                      <!-- <v-select
                        filled
                        rounded
                        dense

                        :color="set_color"
                        placeholder="2023"

                        hide-details

                        :items="years"
                        :item-color="set_color"

                        clearable
                        @click:clear="filter.year = ''; fetchData(); fetchSkor();"

                        @change="fetchData(); fetchSkor();"

                        v-model="filter.year"
                        class="no_box_white"
                        style="border-radius: 10px;">
                      </v-select> -->

                      <div
                        class="text-right my-2">
                        <strong class="black--text">{{ $route.query.start_date | date_month }}</strong> - <strong class="black--text">{{ $route.query.end_date | fulldate }}</strong>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              
              <v-card 
                flat
                class="mb-6"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  :style="list.length > 0 ? 'height: calc(100vh - 510px);' : 'height: calc(100vh - 438px);'"
                  style="overflow-y: auto;">
                  <v-skeleton-loader
                    v-for="(item, index) in process.load ? 2 : list"
                    :key="index"
                    :loading="process.load"
                    :class="index < list.length -1 ? 'mb-4' : ''"
                    type="article">
                    <v-expansion-panels
                      flat>
                      <v-expansion-panel
                        style="background: #f0f0f0; border-radius: 10px;">
                        <v-expansion-panel-header>
                          <div>
                            <div
                              class="font-weight-bold mb-3"
                              :style="`color: ${set_color};`">
                              {{ item.title }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div
                                class="d-flex align-center mr-8">
                                <v-icon small>mdi-calendar-range</v-icon>
                                
                                <span
                                  class="caption ml-1">
                                  {{ item.datetime | date }}
                                </span>
                              </div>

                              <div
                                class="d-flex align-center">
                                <v-icon small>mdi-clock-time-four-outline</v-icon>
                                
                                <span
                                  class="caption ml-1">
                                  {{ item.datetime | time }} WIB
                                </span>
                              </div>
                            </div>
                          </div>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-divider
                            class="mb-3"
                            style="border: 2px solid #e0e0e0; border-radius: 50px;" />
                            
                          <div
                            class="mb-2"
                            :style="`color: ${set_color}; font-weight: 500;`">
                            Deskripsi Pekerjaan
                          </div>

                          <v-card
                            flat
                            class="mb-4"
                            style="border-radius: 10px;">
                            <v-card-text
                              class="line-text-second"
                              style="padding-top: 12px;">
                              {{ item.desc }}
                            </v-card-text>
                          </v-card>

                          <v-card
                            flat
                            style="border-radius: 10px;">
                            <v-card-text
                              class="line-text-second d-flex align-start"
                              style="padding-top: 12px;">
                              <v-icon>mdi-attachment</v-icon>

                              <span v-if="item.attachment !== ''"
                                @click="dialog.attachment = true; selected.item = item;"
                                class="blue--text cursor-pointer ml-2">
                                {{ item.attachment }}
                              </span>

                              <span v-else
                                class="ml-2">
                                Tidak ada lampiran
                              </span>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-skeleton-loader>

                  <v-card v-if="!process.load && list.length < 1"
                    flat
                    style="border-radius: 10px; border: 2px dashed #e0e0e0;">
                    <v-card-text
                      class="d-flex align-center">
                      <v-icon size="20">mdi-information-slab-circle-outline</v-icon>

                      <span
                        class="ml-2">
                        Belum ada data {{ $route.name.split('Detail')[1] }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-card-text>

                <pagination v-if="pagination.total_data > 0"
                  @changePage="fetchData($event)" 
                  @reloadPage="fetchData($event)" 
                  :model="pagination"/>
              </v-card>

              <v-card 
                flat
                class="mb-6"
                :color="set_color_rgb_down"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-row>
                  <v-col
                    cols="12"
                    md="11"
                    class="py-0 pr-0">
                    <v-card
                      @click="dialog.form = true; reset();"
                      flat
                      color="transparent"
                      style="border-radius: 10px 0px 0px 10px;">
                      <v-card-text
                        class="font-weight-bold black--text">
                        Skor Ketepatan Pekerjaan{{ detail_skor.indicator_label_score === '' ? ', klik disini' : ` adalah ${detail_skor.indicator_score}` }}
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    md="1"
                    class="py-0 pl-0">
                    <v-card
                      flat
                      min-height="56"
                      style="border-radius: 0px 10px 10px 0px;">
                      <v-card-text
                        class="font-weight-bold text-center">
                        {{ detail_skor.indicator_label_score }}%
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>

              <v-card 
                flat
                color="transparent">
                <v-card-actions>
                  <v-spacer/>

                  <v-btn
                    @click="$router.go(-1)"

                    rounded
                    outlined
                    width="120"
                    class="body-2 font-weight-bold text-capitalize red--text">
                    <v-icon color="red" small class="mr-1">mdi-arrow-left-thick</v-icon>

                    Kembali
                  </v-btn>

                  <v-btn v-if="detail_skor.indicator_id !== ''"
                    @click="toReset()"

                    rounded
                    width="140"
                    color="orange"
                    elevation="0"
                    class="body-2 font-weight-bold text-capitalize white--text">
                    <v-icon small class="mr-1">mdi-reload</v-icon>

                    Reset Nilai
                  </v-btn>

                  <v-btn
                    @click="$router.go(-1)"

                    rounded
                    width="190"
                    color="green"
                    elevation="0"
                    class="body-2 font-weight-bold text-capitalize white--text">
                    <v-icon small class="mr-1">mdi-check-bold</v-icon>

                    Simpan Penilaian
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,
          
          form: false,
          reset: false,
          attachment: false
        },

        filter: {
          month: new Date().getMonth() + 1,
          year: new Date().getFullYear(),
          unit_id: '',
          unit_name: ''
        },

        max_date: moment().format('YYYY-MM-DD'),

        selected: {
          item: {},
          reset: {}
        },

        info: [
          // 'Kurang dari 70 (<b class="red--text">Kurang Berkinerja</b>)',
          // 'Lebih dari sama dengan 70 sampai dengan kurang dari 80 (<b class="orange--text">Berkinerja Cukup</b>)',
          // 'Lebih dari sama dengan 80 sampai dengan kurang dari 90 (<b class="blue--text">Berkinerja Baik</b>)',
          // 'Lebih dari sama dengan 90 (<b class="green--text">Berkinerja Baik Sekali</b>)'

          'Kurang dari 50% (Skor 20)',
          'Lebih dari 50% sampai dengan 60% (Skor 40)',
          'Lebih dari 60% sampai dengan 70% (Skor 60)',
          'Lebih dari 70% sampai dengan 80% (Skor 80)',
          'Lebih dari 80% (Skor 100)'
        ],

        unit: [],
        master_category_score: [],
        
        detail: {},
        detail_skor: {},

        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          user_id: '',
          label_score: '',

          start_date: '',
          end_date: '',
          note: ''
        },

        picker: {
          start: false,
          end: false
        },

        process: {
          load: false,

          form: false,
          reset: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'filter.unit_id': function() {
        let self = this
        let data = this.unit.filter(function(v) {
          return self.filter.unit_id == v.id
        })

        if (data.length > 0) {
          this.filter.unit_name = data[0].name
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      months () {
        let numb = new Date().getMonth() + 1
        
        this.filter.month = numb < 10 ? `0${numb}`.toString() : numb.toString()

        return [
          {
            text: 'Januari',
            value: '01'
          },
          {
            text: 'Februari',
            value: '02'
          },
          {
            text: 'Maret',
            value: '03'
          },
          {
            text: 'April',
            value: '04'
          },
          {
            text: 'Mei',
            value: '05'
          },
          {
            text: 'Juni',
            value: '06'
          },
          {
            text: 'Juli',
            value: '07'
          },
          {
            text: 'Agustus',
            value: '08'
          },
          {
            text: 'September',
            value: '09'
          },
          {
            text: 'Oktober',
            value: '10'
          },
          {
            text: 'November',
            value: '11'
          },
          {
            text: 'Desember',
            value: '12'
          }
        ]
      },
      years () {
        let max = new Date().getFullYear(), min = max - 10, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchUser()
        this.fetchData()
        this.fetchSkor()
      },

      async fetchUser () {
        let params = {
          id: this.$route.params.id
        }

        await get('admin/user/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      async fetchData (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,

          user_id: this.$route.params.id,

          unit_id: this.filter.unit_id,
          // month: this.filter.month,
          // year: this.filter.year,

          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date
        }

        await get(`kpi/ketepatan/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.list = res.results.data
            this.pagination = res.results.pagination
          }
        })
      },

      async fetchSkor () {
        let params = {
          user_id: this.$route.params.id,

          unit_id: this.filter.unit_id,
          // month: this.filter.month,
          // year: this.filter.year,

          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date
        }

        await get('kpi/ketepatan/data', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail_skor = res.results.data.length > 0 ? res.results.data[0] : {
              indicator_label_score: 0,
              indicator_score: 0
            }
          }
        })
      },

      async fetchUnit () {
        let params = {
          limit: 100000
        }

        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
          }
        })
      },

      async fetchCategoryScore () {
        let params = {
          limit: 100000
        }

        await get('admin/kategori_penilaian/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.master_category_score = res.results.data
          }
        })
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: this.detail_skor.indicator_id,
          user_id: this.detail.id,
          label_score: this.detail_skor.indicator_label_score,

          start_date: this.detail_skor.indicator_period_start_date,
          end_date: this.detail_skor.indicator_period_end_date,
          note: this.detail_skor.indicator_kategori_penilaian
        }

        this.picker = {
          start: false,
          end: false
        }

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) this.fetchCategoryScore()
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.detail_skor.indicator_label_score === '' ? 'kpi/ketepatan/add_score' : 'kpi/ketepatan/update_score'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchSkor()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toReset () {
        this.selected.reset = this.detail_skor

        this.dialog.reset = true
      },

      async resetes () {
        this.message.error = ''

        this.process.reset = true

        await post(`kpi/ketepatan/reset_score`, {
          data: {
            id: this.selected.reset.indicator_id
          }
        }).then(response => {
          let res = response.data

          this.process.reset = false

          if (res.status === 200) {

            this.dialog.reset = false

            this.selected.reset = {}
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchSkor()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>